<template>
  <nx-bform-group :label="name" v-bind="$attrs">
    <!-- name is 'captcha', which is set by nx-libs -->
    <nx-bform-captcha                                                                              ha
      :rules="{ required }"
      :value="$attrs.value"
      @input="$listeners.input"
      @change-token="$listeners['change-token']"
    />
  </nx-bform-group>
</template>

<script>
import FormGroupMixin from "../form-group.mixin";
import { localize } from "vee-validate";

localize({
  en: {
    names: {
      captcha: "Captcha"
    }
  },
  zh_hk: {
    names: {
      captcha: "驗證碼"
    }
  },
  zh_cn: {
    names: {
      captcha: "验证码"
    }
  }
});

export default {
  mixins: [FormGroupMixin],
  props: {
    label: {
      type: String
    }
  },
  data() {
    return {
      clear: false
    };
  },
  computed: {
    name() {
      return this.label || this.$t("captcha");
    }
  },
  mounted() {
    let timeID = setInterval(() => {
      let target = $(this.$parent.$el)
        .find(".botdetect-captcha")
        .find(".BDC_CaptchaImageDiv")
        .find("a");
      if (target) {
        this.clear = true;
        target.remove();
      }
    }, 10);
    if (this.clear) {
      clearInterval(timeID);
    }
  }
};
</script>

<i18n>
{
  "en": {
    "captcha" : "Captcha"
  },
  "zh_hk": {
    "captcha" : "驗證碼"
  },
  "zh_cn": {
    "captcha" : "验证码"
  }
}
</i18n>
